import { Pencil } from "lucide-react";
import { StepFrame } from "@/features/onboarding/components/StepFrame";
import { NeedsCard } from "@/features/onboarding/components/StudioSteps";
import { useProfileTheme } from "@/features/profiles/hooks/useProfileTheme";
import { ProfilePhonePreview, ThemeLoadState } from "@/features/profiles/components/ProfileThemeEditor";
import { CardRenderer } from "@/features/cards/templates/cardBackgrounds";

const EditButton = ({ onClick, testId, children }) => (
  <button type="button" onClick={onClick} data-testid={testId} className="mw-link inline-flex min-h-[44px] items-center gap-2 text-sm">
    <Pencil className="h-3.5 w-3.5" /> {children}
  </button>
);

export function PreviewStep({ step, onBack, onNext, onEdit }) {
  const t = useProfileTheme();
  const ready = t.load.status === "ready";
  const complete = ready && Boolean(t.load.card && t.load.pp);
  let body = <ThemeLoadState t={t} />;
  if (ready && !complete) body = <NeedsCard testId="preview-needs-card" />;
  if (complete) {
    body = (
      <div className="grid gap-10 lg:grid-cols-[1fr_400px] lg:items-start">
        <section>
          <div className="mb-4 flex items-center justify-between">
            <p className="mw-eyebrow">Digital business card</p>
            <EditButton onClick={() => onEdit("card")} testId="preview-edit-card-button">Edit card</EditButton>
          </div>
          <div data-testid="preview-card" className="drop-shadow-[0_24px_40px_rgba(0,0,0,0.12)]">
            <CardRenderer templateId={t.load.card.template_id} identity={t.identity} idPrefix="preview" />
          </div>
          <p className="mt-4 break-all font-mono text-[11px] text-muted-foreground" data-testid="preview-profile-url">{t.identity.publicProfileUrl}</p>
        </section>
        <section>
          <div className="mb-4 flex items-center justify-between">
            <p className="mw-eyebrow">Public profile</p>
            <EditButton onClick={() => onEdit("profile")} testId="preview-edit-profile-button">Edit profile</EditButton>
          </div>
          <ProfilePhonePreview identity={t.identity} theme={t.theme} testId="preview-profile" />
        </section>
      </div>
    );
  }
  return (
    <StepFrame step={step} onBack={onBack} onNext={onNext} nextLabel="Continue to Payment" nextDisabled={!complete}>
      {body}
    </StepFrame>
  );
}
